import type { KeyboardEvent } from 'react';

export interface SecretShareOptions { expiresInHours: number; recipientEmail: string }
export interface SharedSecret {
  shareId: string; label: string; kind: string; status: 'active' | 'viewed' | 'expired' | 'revoked';
  createdAt: string; expiresAt: string; viewedAt?: string | null; recipientEmail?: string | null;
  emailStatus?: 'pending' | 'sent' | 'failed' | null; emailHistoryWarning?: string; shareUrl?: string;
}
export const sharedSecretWritePermissions = ['shared_secret:write', 'transactional_api_key:write', 'marketing_api_key:write', 'web_api_key:write', 'smtp:write'];
export const sharedSecretReadPermissions = ['shared_secret:read', ...sharedSecretWritePermissions];
export const defaultShareOptions: SecretShareOptions = { expiresInHours: 24, recipientEmail: '' };
export const secretInputClass = 'w-full rounded-md border border-zinc-300 bg-white px-3 py-2 text-sm text-zinc-900 focus:outline-none focus:ring-2 focus:ring-cyan-500 dark:border-zinc-700 dark:bg-zinc-950 dark:text-zinc-100';
export const secretButtonClass = 'inline-flex h-9 items-center justify-center rounded-md bg-cyan-600 px-3 text-xs font-medium text-white hover:bg-cyan-700 disabled:opacity-50';
export function secretDialogKeyDown(event: KeyboardEvent<HTMLElement>, close: () => void, busy: boolean) {
  if (event.key === 'Escape') {
    event.preventDefault();
    event.stopPropagation();
    if (!busy) close();
    return;
  }
  if (event.key !== 'Tab') return;
  const controls = Array.from(event.currentTarget.querySelectorAll<HTMLElement>('input:not(:disabled), textarea:not(:disabled), select:not(:disabled), button:not(:disabled), a[href]'));
  const first = controls[0];
  const last = controls[controls.length - 1];
  if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
  if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
}
